module.exports = __webpack_public_path__ + "img/logo-big.39fa9c0c.png";